/*
 * File: view-area.ts
 * File Created: 2024-02-02 10:59:57
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:53:57
 * Modified By: Val Liu
 * -----
 */

import { Vue, Component } from "vue-property-decorator";

@Component
export default class ViewArea extends Vue {}
